import { ApiService } from '../../theme/utils/api.service';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NoInternetHelper } from '../../theme/utils/no-internet-helper';
import { ChargeExceptionnelle } from '../../model/syndic/charge-exceptionnelle';

@Injectable({
  providedIn: 'root'
})
export class ChargeExceptionnelleService {

  chargeExceptionnelle: ChargeExceptionnelle;
  public edit: boolean = false;
  public houseCoUuid: string = '';
  private url = 'private/trustee/chargeexceptionnelle';

  constructor(private api: ApiService) { }

  setChargeExceptionnelle(charge: ChargeExceptionnelle) {
    this.chargeExceptionnelle = charge;
  }

  getChargeExceptionnelle(): ChargeExceptionnelle {
    return this.chargeExceptionnelle;
  }

  add(data: ChargeExceptionnelle): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    if (data.uuid) {
      return this.update(data);
    } else {
      return this.create(data);
    }
  }

  create(data: ChargeExceptionnelle): Observable<any> {
    return this.api._post(`${this.url}/new`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  update(data: ChargeExceptionnelle): Observable<any> {
    return this.api._post(`${this.url}/${data?.uuid}/edit`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  getList(houseCo?: string): Observable<any[]> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    return this.api._get(`${this.url}`, { houseCo: houseCo }).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  getSingle(uuid: string): Observable<ChargeExceptionnelle> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    return this.api._get(`${this.url}/${uuid}/show`).pipe(
      map((response: any) => response.data),
      catchError((error: any) => throwError(error))
    );
  }

  getDelete(uuid: string): Observable<ChargeExceptionnelle> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    return this.api._delete(`${this.url}/${uuid}/delete`).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
}
